import React from "react";
import { RichText } from "prismic-reactjs";
import NotFound from "../NotFound";
import Loader from "../Loader";
import PageHeader from "../PageHeader";
import Team from "../slices/Team";
import Trustee from "../slices/Trustee";
import AdvisoryCouncil from "../slices/AdvisoryCouncil";
import Text from "../slices/Text";

export default class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      doc: null,
      notFound: false,
      team: [],
      trustees: [],
      advisoryCouncil: [],
      textSlice: null
    };
    if (props.prismicCtx) {
      this.fetchPage(props);
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.prismicCtx) {
      this.fetchPage(this.props);
    }
  }

  fetchPage(props) {
    return props.prismicCtx.api.getSingle("about_us").then(doc => {
      if (doc) {
        const team = doc.data.body.filter(item => item.slice_type === "team");
        const trustees = doc.data.body.filter(
          item => item.slice_type === "trustees"
        );
        const advisoryCouncil = doc.data.body.filter(
          item => item.slice_type === "advisory_council"
        );
        const textSlice = doc.data.body.find(
          item => item.slice_type === "text"
        );

        this.setState({ doc, team, trustees, advisoryCouncil, textSlice });
      } else {
        this.setState({ notFound: !doc });
      }
    });
  }

  renderTeam() {
    return (
      <div className="container">
        {this.state.team.map((item, index) => {
          return (
            <Team key={index} prismicCtx={this.props.prismicCtx} data={item} />
          );
        })}
      </div>
    );
  }

  renderTrustees() {
    return (
      <div className="bg-blue text-white pt-5 pb-5">
        <div className="container">
          {this.state.trustees.map((item, index) => {
            return (
              <Trustee
                key={index}
                prismicCtx={this.props.prismicCtx}
                data={item}
              />
            );
          })}
        </div>
      </div>
    );
  }

  renderAdvisoryCouncil() {
    return (
      <div className="container">
        {this.state.advisoryCouncil.map((item, index) => {
          return (
            <AdvisoryCouncil
              key={index}
              prismicCtx={this.props.prismicCtx}
              data={item}
            />
          );
        })}
      </div>
    );
  }

  render() {
    if (this.state.doc) {
      const doc = this.state.doc;

      return (
        <div>
          <PageHeader
            title={RichText.asText(
              doc.data.title,
              this.props.prismicCtx.linkResolver
            )}
          />

          <div className="container pt-5 pb-5">
            <div className="row">
              <div className="col-12 col-md-4 col-lg-5 order-md-last">
                <img
                  src={doc.data.main_image.url}
                  className="img-fluid btn-block mb-5 main-image"
                  alt=""
                />
              </div>
              <div className="col-12 col-md-8 col-lg-7 order-md-first">
                <div className="about-us-content">
                  {RichText.render(
                    doc.data.content,
                    this.props.prismicCtx.linkResolver
                  )}
                </div>
              </div>
            </div>
          </div>

          {this.state.team.length > 0 ? this.renderTeam() : null}
          {this.state.trustees.length > 0 ? this.renderTrustees() : null}
          {this.state.advisoryCouncil.length > 0
            ? this.renderAdvisoryCouncil()
            : null}
          {this.state.textSlice ? (
            <Text
              prismicCtx={this.props.prismicCtx}
              data={this.state.textSlice}
            />
          ) : null}
        </div>
      );
    } else if (this.state.notFound) {
      return <NotFound />;
    }
    return <Loader />;
  }
}



// WEBPACK FOOTER //
// ./src/components/pages/AboutUs.js